import { render, staticRenderFns } from "./EditPopup.vue?vue&type=template&id=4c2971b8&scoped=true&"
import script from "./EditPopup.vue?vue&type=script&lang=js&"
export * from "./EditPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditPopup.vue?vue&type=style&index=0&id=4c2971b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2971b8",
  null
  
)

export default component.exports